import * as React from 'react'
import { memo } from 'react'
const SvgGlass = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.078 16">
    <path d="M1.818 16v-.727h2.857v-4.831A5.15 5.15 0 0 1 1.22 8.533 5.78 5.78 0 0 1 0 4.883V0h10.078v4.883a5.78 5.78 0 0 1-1.221 3.649 5.15 5.15 0 0 1-3.455 1.909v4.831h2.857V16ZM.727 4.52H9.35V.728H.727Z" />
  </svg>
)
const Memo = memo(SvgGlass)
export default Memo
